import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Icon from '@mdi/react';
import { mdiFileExcel } from '@mdi/js';
import { BsFileEarmarkPdf } from "react-icons/bs";
import { _ } from '../../functions/translator';
import { openWindowWithPost } from '../../functions/postData';

class ExportWhatsAppButton extends React.Component {
          
    handleExport = () => {
        const projectId = window.project_id;
        
        // Only send the selected observation IDs, no filters
        // Filters should only apply when exporting all observations, not specific selections
        console.log("selectedWhatsAppObservations:", this.props.selectedWhatsAppObservations)
        const params = {
            project_id: projectId,
            whatsappobservation_id: this.props.selectedWhatsAppObservations.join(','),
            fileType: this.props.fileType
        };
        
        console.log("params being sent:", params)
        const url = '/whatsapp-observations-pdf';
        openWindowWithPost(url, params, true);
    }

    renderIcon = () => {
        const { fileType } = this.props;
        
        if (fileType === 'pdf') {
            return <BsFileEarmarkPdf size={30} color='white' style={{margin: 10}} />;
        } else if (fileType === 'excel') {
            return <Icon path={mdiFileExcel} size='30px' color='white' style={{margin: 10}}/>;
        }
        
        return null;
    }

    getButtonText = () => {
        const { fileType } = this.props;
        
        if (fileType === 'pdf') {
            return _('Exportar PDF');
        } else if (fileType === 'excel') {
            return _('Exportar Excel');
        }
        
        return _('Exportar');
    }

    render() {
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleExport}>
                    <div className='d-inline-flex'>
                        {this.renderIcon()}
                        <p>{this.getButtonText()}</p>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedWhatsAppObservations: state.whatsappObservations.selectedObservations,
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ExportWhatsAppButton);

